import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function WellnessGuidancePage() {
  const navigate = useNavigate();
  const [sliderPercent, setSliderPercent] = useState(30);
  const [isDragging, setIsDragging] = useState(false);
  const trackRef = useRef(null);

  const updateSlider = (clientX) => {
    if (!trackRef.current) return;
    
    const rect = trackRef.current.getBoundingClientRect();
    let percent = ((clientX - rect.left) / rect.width) * 100;
    percent = Math.max(0, Math.min(100, percent));
    
    setSliderPercent(percent);
  };

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      updateSlider(e.clientX);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = () => {
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (isDragging) {
      updateSlider(e.touches[0].clientX);
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  const handleTrackClick = (e) => {
    updateSlider(e.clientX);
  };

  const handleBeginClick = () => {
    if (sliderPercent >= 95) {
      navigate('/health-log');
    }
  };

  const isComplete = sliderPercent >= 95;

  return (
    <section 
      className="wellness-section"
      style={{ background: 'var(--bg-dark)' }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className="wellness-container">
        <div className="logo-circle">
          <svg className="lotus-icon" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
            <path d="M32 8c0 0-4 8-4 16s4 16 4 16 4-8 4-16-4-16-4-16z" fill="var(--primary)"/>
            <path d="M32 40c-8-8-20-10-20-10s4 12 12 18c4 3 8 4 8 4s4-1 8-4c8-6 12-18 12-18s-12 2-20 10z" fill="var(--primary)"/>
            <path d="M18 24c0 0 2 8 8 12M46 24c0 0-2 8-8 12" fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>

        <h1 className="wellness-title" style={{ color: 'var(--text-light)' }}>What's Your Body's Story Today?</h1>
        <p className="wellness-subtitle" style={{ color: 'var(--text-muted)' }}>AI-powered guidance for your well-being</p>

        <div className="slider-section">
          <span className="slider-label" style={{ color: 'var(--text-muted)' }}>I understand this is wellness guidance</span>
          <div 
            className="slider-track" 
            ref={trackRef}
            onClick={handleTrackClick}
          >
            <div 
              className="slider-fill" 
              style={{ width: `${sliderPercent}%`, background: 'var(--primary)' }}
            ></div>
            <div 
              className="slider-thumb"
              style={{ left: `${sliderPercent}%`, cursor: isDragging ? 'grabbing' : 'grab', background: 'var(--primary)', boxShadow: '0 2px 8px rgba(57, 224, 121, 0.4)' }}
              onMouseDown={handleMouseDown}
              onTouchStart={handleTouchStart}
            ></div>
            <span className="slider-arrow">→</span>
          </div>

          <button 
            className={`begin-button ${isComplete ? 'complete' : ''}`}
            style={{ 
              background: isComplete ? 'var(--primary)' : 'var(--btn-disabled-bg)',
              color: isComplete ? 'var(--bg-dark)' : 'var(--btn-disabled-text)'
            }}
            onClick={handleBeginClick}
          >
            {isComplete ? "Let's Begin!" : "Slide to begin"}
          </button>
        </div>
      </div>
    </section>
  );
}

export default WellnessGuidancePage;